import withStyles from '@material-ui/core/styles/withStyles'
import MuiButton from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import React from 'react'

const SubmitButtonSection = () => {
  const Button = withStyles({ root: { textTransform: 'none' } })(MuiButton)

  return (
    <Grid item xs={12} className='w-100'>
      <div className='pa6 w-100'>
        <Button type='submit' variant='contained' color='primary' classes={{ root: 'white' }}>
          Save
        </Button>
      </div>
    </Grid>
  )
}

export default SubmitButtonSection
